import { render } from "./Invoices.vue?vue&type=template&id=1f9866ba&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"

import "./Invoices.vue?vue&type=style&index=0&id=1f9866ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9866ba"]])

export default __exports__